import React, { useEffect } from 'react'
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getBrowseStudentApprovedDetailData } from '../../../../Redux/action/TutorAction'
import Beatloader from '../../../../Common/BeatLoader'
import moment from 'moment/moment'

const host = process.env.REACT_APP_API_SERVER
const TutorMyCourseDetails = () => {

    const dispatch = useDispatch();
    const { b64id } = useParams();

    const navigate = useNavigate();
    const location = useLocation();
const BrowseStudentApprovedDetailApiData = location.state.data


    useEffect(() => {
        try {

          
            if (!location || !location?.state || !location?.state?.data) {
                navigate(-1);
            }

            // dispatch(getBrowseStudentApprovedDetailData(requestId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);


    const {

        // loadingBrowseStudentApprovedDetailApi,
        // BrowseStudentApprovedDetailApiData,
        // BrowseStudentApprovedDetailApiError
    } = useSelector(state => state?.TutorReducer);


    console.log(BrowseStudentApprovedDetailApiData)

    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Course Details
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {/* {loadingBrowseStudentApprovedDetailApi ?
                                    <Beatloader />
                                    : */}
                                    <div className="my-schedule-detail-sec">
                                        <div className="row">
                                            <div className="col-lg-2">
                                                <img src={`${host}${BrowseStudentApprovedDetailApiData?.student?.profile_img}`} className="img-fluid w-auto" onError={(e) => {
                                                    e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                }} />
                                            </div>
                                            <div className="col-lg-7">
                                                <h4 className="mb-0 mt-4 fw-bold">{BrowseStudentApprovedDetailApiData?.student?.name}</h4>
                                                <p className="mb-0 text-primary fw-bold">{BrowseStudentApprovedDetailApiData?.reqCourse?.childcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0 mt-2 fw-bold">
                                                    <i className="fa-solid fa-calendar-days" /> Scheduled Date
                                                </p>
                                                <p className="mb-0 ms-4 text-primary fw-bold">{BrowseStudentApprovedDetailApiData?.format_start_date}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-4 mb-3">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Class/Grade/General</p>
                                                <p className="mb-0 fw-bold">{BrowseStudentApprovedDetailApiData?.reqCourse?.category?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Subject</p>
                                                <p className="mb-0 fw-bold">{BrowseStudentApprovedDetailApiData?.reqCourse?.subcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Module</p>
                                                <p className="mb-0 fw-bold">{BrowseStudentApprovedDetailApiData?.reqCourse?.childcategory?.name}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Session Start date</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentApprovedDetailApiData?.format_start_date}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Session End date</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentApprovedDetailApiData?.format_end_date}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Timing</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentApprovedDetailApiData?.time_slot?.start_time_convert} - {BrowseStudentApprovedDetailApiData?.time_slot?.end_time_convert} ({BrowseStudentApprovedDetailApiData?.time_slot?.timeZoneAbb})</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Created at</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentApprovedDetailApiData?.createdAt?BrowseStudentApprovedDetailApiData?.createdAt?.split(" ")?.[0]:''}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-5">
                                        <h6 className="mb-0">Course Sessions</h6>
                                        {BrowseStudentApprovedDetailApiData?.reqCourse?.courseSession?.map((data, index) => (

                                                <div className="col-lg-4 my-2">
                                                    <div className="card bg-white" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                        <div className="card-body" >
                                                        <h6 className="text-primary">Session - {index+1}</h6>
                                                            <div className='d-flex justify-content-between'>
                                                                <h6 className="text-primary">Start Date: {data?.formated_start_date}  </h6>
                                                               
                                                            </div>

                                                            <h6 className="text-primary">Time Slot: {data?.timeslots?.formated_start_end_time} ({data?.timeslots?.timeZoneAbb})</h6>
                                                            <h6 className="text-primary">Topic Details: {data?.topic_details}</h6>
                                                           
                                                        </div>
                                                    </div>
                                                </div>


                                            ))}
                                        </div>
                                        {/* <hr/> */}
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td>Course Name: {BrowseStudentApprovedDetailApiData?.reqCourse?.name}</td>
                                                    <td />
                                                </tr>
                                                <tr>
                                                    <td>No. of Session</td>
                                                    <td>{BrowseStudentApprovedDetailApiData?.reqCourse?.no_of_session}</td>
                                                </tr>
                                                <tr>
                                                    <td>Per Session Tutor Price</td>
                                                    <td>$ {BrowseStudentApprovedDetailApiData?.reqCourse?.per_session_price}</td>
                                                </tr>
                                                <tr>
                                                    <td>Per Session Plateform Charge</td>
                                                    <td>$ {BrowseStudentApprovedDetailApiData?.reqCourse?.per_session_plate_form_price}</td>
                                                </tr>
                                                <tr>
                                                    <td>Course Main Price</td>
                                                    <td>$ {BrowseStudentApprovedDetailApiData?.reqCourse?.course_main_price}</td>
                                                </tr>
                                                <tr>
                                                    <td>Course Discount Price</td>
                                                    <td>$ {BrowseStudentApprovedDetailApiData?.reqCourse?.course_discount_price}</td>
                                                </tr>
                                                <tr>
                                                    <td>After Discount Course Price</td>
                                                    <td>$ {BrowseStudentApprovedDetailApiData?.reqCourse?.total_course_price}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <p>Description: {BrowseStudentApprovedDetailApiData?.reqCourse?.description}</p>
                                                {/* <p>Course Session</p> */}
                                            </div>
                                            {/* <div className="col-lg-6 d-flex justify-content-end align-items-center">
                                                <button
                                                    className="btn btn-primary me-5"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal2"
                                                >
                                                    View Course Session
                                                </button>
                                            </div> */}
                                        </div>
                                    </div>
                                    {/* } */}
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Modal */}
                <div
                    className="modal fade"
                    id="exampleModal2"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Course Session: {BrowseStudentApprovedDetailApiData?.reqCourse?.name}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                {BrowseStudentApprovedDetailApiData?.reqCourse?.courseSession?.map((data, index) => (
                                    <div key={data?.id} className='mt-2 border-bottom'>
                                        <h6 className="text-secondary">Session - {index + 1}</h6>
                                        <h6 className="text-primary">Start Date : {data?.formated_start_date}</h6>
                                        <h6 className="text-primary">Time Slot : {data?.timeslots?.formated_start_end_time} ({data?.timeslots?.timeZoneAbb})</h6>
                                        <h6 className="text-primary">Topic Details : {data?.topic_details}</h6>
                                    </div>))}
                            </div>
                            <div className="modal-footer py-4"></div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default TutorMyCourseDetails